<script lang="ts" setup>
    import type { Alert } from "common";

    const { alert } = defineProps<{
        alert: Alert | undefined;
    }>();
</script>
<template>
    <VAlert
        v-if="alert !== undefined"
        :type="alert.type"
        class="mb-4"
        dense
        outlined
    >
        {{ alert.text }}
    </VAlert>
</template>
